import React, {Component} from "react";
import SecureLayout from "./../../../templates/secure";

class ActivitiesSearch extends Component {
	render() {
		const { activities } = this.props;
		return <div className="field has-addons">
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._clearSearch}>
					&nbsp;&nbsp;
					<span className="icon is-small">
						<i className="fa fa-ban"/>
					</span>
				</a>
			</div>
			<div className="control">
				<input className="input is-small" type="search" ref="q" id="q" placeholder="Buscar" value={activities.filters.q} onChange={this._searchChange}/>
			</div>
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._submitSearch}>Buscar</a>
			</div>
		</div>
	}

	constructor() {
		super();
		this._submitSearch = this._submitSearch.bind(this);
		this._searchChange = this._searchChange.bind(this);
		this._clearSearch = this._clearSearch.bind(this);
	}

	_submitSearch() {
		const {activities} = this.props;
		this.props.activitiesShow(1,activities.filters);
	}

	_searchChange(event){
		this.props.change('activities.filters.q',event.target.value);
	}

	_clearSearch(){
		this.props.reset('activities.filters');
		this.props.activitiesShow(1);
	}
}

export default SecureLayout(ActivitiesSearch);



// WEBPACK FOOTER //
// ./src/elements/activities/widget/activities_search.jsx